// extracted by mini-css-extract-plugin
export var fadeInOut = "_2m-3";
export var icon = "_2m-4";
export var savedIndicator = "_2m-2";
export var savingIndicator = "_2m-0";
export var spin = "_2m-1";